import { useTranslation } from "react-i18next"
import { ResourceContentSection } from "@/components/molecules/ResourceContentSection/ResourceContentSection"

export function CookiesContent() {
  const { t } = useTranslation()

  const contentItems = [
    { type: "heading1" as const, content: t("cookies.introduction.title") },
    { type: "paragraph" as const, content: t("cookies.introduction.content") },

    { type: "heading2" as const, content: t("cookies.what.title") },
    { type: "paragraph" as const, content: t("cookies.what.content") },
    { type: "paragraph" as const, content: t("cookies.what.types") },

    { type: "heading1" as const, content: t("cookies.why.title") },
    { type: "paragraph" as const, content: t("cookies.why.content") },

    { type: "heading2" as const, content: t("cookies.types.title") },
    {
      type: "list" as const,
      content: [
        t("cookies.types.essential"),
        t("cookies.types.performance"),
        t("cookies.types.analytics"),
        t("cookies.types.advertising"),
      ],
    },

    { type: "heading1" as const, content: t("cookies.control.title") },
    { type: "paragraph" as const, content: t("cookies.control.content") },
    { type: "paragraph" as const, content: t("cookies.control.browser") },

    { type: "heading2" as const, content: t("cookies.update.title") },
    { type: "paragraph" as const, content: t("cookies.update.content") },

    { type: "heading2" as const, content: t("cookies.contact.title") },
    { type: "paragraph" as const, content: t("cookies.contact.content") },

    { type: "heading2" as const, content: t("cookies.compliance.title") },
    { type: "paragraph" as const, content: t("cookies.compliance.content") },
  ]

  return <ResourceContentSection items={contentItems} />
}
